<template>
  <v-app>
    <recipient-drawer v-model="drawer" v-if="!isCanteen" />
    <v-app-bar app color="#fff8f5" v-if="!isCanteen">
      <img
        style="width: 50px"
        :src="'https://restorani.bitlab.host/img/o.png'"
        alt="image"
      />
      <v-toolbar-title class="ml-2">
        {{ toLatin(restaurant?.name) || toLatin(company?.name) }}
      </v-toolbar-title>
      <v-spacer />
      <dropdown
        v-model="$i18n.locale"
        :items="languages"
        hide-details
        item-value="code"
        item-text="name"
        @change="setLang"
      ></dropdown>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>
    <v-main>
      <slot></slot>
    </v-main>
  </v-app>
</template>

<script>
import setLang from "@/mixins/setLang";
import RecipientDrawer from "./components/RecipientDrawer.vue";
export default {
  name: "RecipientLayout",
  mixins: [setLang],
  components: {
    RecipientDrawer,
  },
  data() {
    return {
      drawer: false,
    };
  },
  computed: {
    isCanteen() {
      return ["canteen", "naplata2", "canteen-testing"].includes(this.$route.name);
    },
    restaurant() {
      return this.$store.state.restaurant;
    },
    company() {
      return this.$store.state.company;
    },

    languages() {
      const fallbackLanguage = [
        { code: "sr", name: "Српски - ћирилица", cir_to_lat: 0 },
        {
          code: "sr-lat",
          name: "Srpski - Latinica",
          cir_to_lat: 1,
        },
        { code: "rs", name: "Ћирилица", cir_to_lat: 0 },
        { code: "rs-lat", name: "Latinica", cir_to_lat: 1 },
        { code: "hr", name: "Hrvatski", cir_to_lat: 1 },
        { code: "bs", name: "Bosanski", cir_to_lat: 1 },
        { code: "en", name: "English", cir_to_lat: 0 },
        { code: "mk", name: "Македонски", cir_to_lat: 0 },
        { code: "si", name: "Slovenščina", cir_to_lat: 0 },
      ];
      return this.restaurant?.settings?.language || fallbackLanguage;
    },
  },
};
</script>
